import { render } from "./Forget.vue?vue&type=template&id=3d120e34"
import script from "./Forget.vue?vue&type=script&lang=ts"
export * from "./Forget.vue?vue&type=script&lang=ts"

import "./Forget.vue?vue&type=style&index=0&id=3d120e34&lang=css"
script.render = render

export default script